export default __webpack_public_path__ + "static/media/Community-living-KID-2025.add4434a.pdf";